import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CustomersApi from '../api/customers/customers.ts';

export const fetchCustomersAsync = createAsyncThunk(
  'customers/fetchCustomers',
  async () => {
    const response = await CustomersApi();
    return response;
  }
);

const customerSlice = createSlice({
  name: 'customers',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    updateCustomerRow: (state, action) => {
      const { id_customer, status_name } = action.payload; 
      const customer = state.data.find(c => c.id_customer === id_customer);
      if (customer) {
        customer.name_status = status_name;
      }
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomersAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomersAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCustomersAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { updateCustomerRow } = customerSlice.actions;
export default customerSlice.reducer;